<template>
    <div>
			<h1 class="my-5" v-html="mainTitle" />

			<b-form>
					<div class="mb-5" v-if="services.domiciliation.domiciliation.type === 'Transfert'">
						<h2 class="mb-5"><b>Packs</b> "Transfert d'entreprise"</h2>

						<b-row v-if="services.domiciliation.company.legalForm !== 'Auto-Entrepreneur / Micro-Entreprise'">
							<b-col cols="12" lg="4" class="mb-5"
							v-for="(pack, index) in services.creation.packs"
							:key="index">
								<OptionRadio
								:index="index"
								:pack="pack"
								:legalForm="services.domiciliation.company.legalForm"
								@radioChange="commitPack" />
							</b-col>
						</b-row>

						<OptionRadio
						v-else
						:index="0"
						:pack="services.creation.packs[0]"
						:legalForm="services.domiciliation.company.legalForm"
						@radioChange="commitPack" />
					</div>

					<OptionCheckbox
					v-for="(option, index) in services.domiciliation.options"
					:key="index"
					:index="index"
					:option="option"
					@checkboxChange="commitOptions" />
			</b-form>
  </div>
</template>

<script>
    import { mapState } from 'vuex'

    import OptionCheckbox from '../OptionCheckbox.vue'
    import OptionRadio from '../OptionRadio.vue'

    export default {
        components: {
					OptionCheckbox,
					OptionRadio
        },
        data() {
					return {
						mainTitle: `Choisissez vos <b>options</b>`,
					};
        },
        methods: {
					commitOptions(lastOptionClicked) {
						this.$store.commit('updateDomiciliationOptions', {
							lastOptionClicked: lastOptionClicked
						})
					},
					commitPack(activePack) {
						this.$store.commit('updateDomiciliationPack', { activePack: activePack })
					}
        },
        computed: {
					...mapState(['services'])
        },
        created() {
					if (this.services.domiciliation.domiciliation.type === "Transfert") {
						this.packs[0].advantages = [
							"Relecture du dossier",
							"Rédaction statuts + m2 + Déclaration de non condamnation et d’affiliation",
							"Mise en conformité du dossier pour les institutions"
						]
					}
        }
    };
</script>
